import {useState, useContext} from "react";
import {Dialog} from "@material-ui/core"
import styles from '../../Payroll/Modals/PayrollModals.module.css'
import { clearPayrollProcess } from "../../../context/PayrollProcess/Actions";
import { useMutation } from "@apollo/client";
import { CREACION_TOKEN_DISPERSION, GET_ENTERPRISE_CENTRAL_PAGOS, GET_PAYROLL_DISPERSION_2, SEND_DISPERSION_CENTRAL_PAGOS, SEND_DISPERSION_FACTURACION_PAGOS } from "../../../Querys/querys";
import { SuccessfulAlert } from "../../../alerts/successAlerts";
import { v4 as uuidv4} from 'uuid'
import CentralPagosContext from "../../../context/CentralPagos/CentralPagosContext";
import { clearDispersar } from "../../../context/CentralPagos/Actions";

const AceptarDispersarCentalPagos = (props:any) =>{
  const {totalesDispersar, totales, seleccionados, idRegistro} = props
  const {state, dispatch} = useContext(CentralPagosContext)
  const [activo, setactivo] = useState(false)
  const [activoMensajeDos, setactivoMensajeDos] = useState(false)
  const [mensaje, setMensaje] = useState('Uno')
  const [token, setToken] = useState('')
  const [sendDispersion] = useMutation(SEND_DISPERSION_CENTRAL_PAGOS,{
    refetchQueries:[
      {query: GET_ENTERPRISE_CENTRAL_PAGOS, variables:{getEnterpriseCentralPagosId: props.empresa}}
    ]
  })
  const [creacionToken] = useMutation(CREACION_TOKEN_DISPERSION,{
  })

  const handleClose = () =>{
    clearDispersar({}, dispatch)
  }

  const handleChange = (e: any) =>{
    if(e.target.value === 'CONFIRMAR'){
        setactivo(true)
    }else{
        setactivo(false)
    }
  }

  const agregaSeleccionados = async() =>{
    const tokenCreado = uuidv4();
    await creacionToken({
      variables:{
        input:{
          Desde: "Nomina",
          idRegistro: parseInt(idRegistro),
          token: tokenCreado,
          numeroRegistros: parseInt(totalesDispersar)
        }
      }
    })
    setMensaje((current) => current = 'Dos')

    //props.setProcesoDispersion(true)
    let Array:any = []
    seleccionados.map((lis:any)=>{
      Array.push({ id: parseInt(lis) })
    })
    await sendDispersion({
      variables:{
        sendDispersionCentralPagosId: Array
      }
    })
  //props.reinicia()
 //   props.setProcesoDispersion(false)

    setactivo(false)
    setactivoMensajeDos((current) => current = false)
    SuccessfulAlert({text: "Registros enviados, por favor espera la respuesta"})
    setMensaje((current) => current ='Uno' )
    //props.updateDataAfterDispersar();
    handleClose()
  }

  return(
    <Dialog aria-labelledby='costumized-dialog-title' open={state.openDispersar} fullWidth={false} maxWidth={"md"}>
      <div className={styles.contenedorPrincipal}>
        <div className={styles.contenedorCerrarModal}>
          {mensaje === 'Tres'?
          null
          :
          <div
          className={styles.cerrarModal}
          onClick={()=> handleClose()}
        >
        </div>
          }

        </div>
        <div className={styles.contenedorPrincipal}>
          <div className={styles.fim_iconoPrincipal}>
            <div className={styles.fim_iconoComplemento}>
            </div>
          </div>
        </div>
        <div className={styles.tituloAtencion}>
          ¡Atenci&oacute;n!
        </div>
        {mensaje === 'Uno'?
          <>
            <div className={styles.em_mensajePrtincipal}>
              Est&aacute;s por dispersar {totalesDispersar}/{totales} de Registros
            </div>
          <div className={styles.em_mensajePrtincipal}>
            Escribe CONFIRMAR para continuar
          </div>
          <div>
              <input
                className={styles.input}
                type="text"
                onChange={(e) => handleChange(e)}
              />
          </div>
          </>
          :null
          }
          {mensaje === 'Dos'?
            <>
              <div className={styles.em_mensajePrtincipal}>
               Dispersi&oacute;n en proceso, no actualices ni cierres la pantalla
              </div>
              <div className={styles.em_mensajePrtincipal}>
              hasta que el proceso haya terminado.
              </div>
              <div className={styles.contenedorLoadingDispersion}>
                <div className={styles.loading}></div>
              </div>
            </>
          : null
          }
        <div className={styles.em_contenedorBotones}>
              {mensaje === 'Dos'?
              null
              :
              <button
                className={styles.em_botonCancelar}
                onClick={()=> handleClose()}
              >
                Cancelar
              </button>
              }
              {mensaje === 'Uno'?
                (activo === true ?
                  <button 
                    className={`${styles.botonesAtencion} ${styles.continuarAtencion}`}
                    onClick={()=> agregaSeleccionados()}
                  >
                    <div>
                      Confirmar
                    </div>
                  </button>
                  :
                  <button
                    className={`${styles.botonesAtencion} ${styles.continuarAtencionInactivo}`}
                  >
                    <div>
                      Confirmar
                    </div>
                  </button>
                )
                :null
              }
            </div>
      </div>
    </Dialog>
  )
}

export default AceptarDispersarCentalPagos